<template>
<div>
     
                        <div style="margin-bottom:10px"><input v-model="name" id="name" :placeholder="$t('form_1')" class="form-control"/></div>
                        <div style="margin-bottom:10px"><input v-model="email" id="email" :placeholder="$t('form_2')" class="form-control"/></div>
                        <div style="margin-bottom:10px"><input v-model="phone" id="phone" :placeholder="$t('form_3')" class="form-control"/></div>
                        <div><textarea class="form-control" rows="6" v-model="content" id="content" :placeholder="$t('form_4')"></textarea></div>
                        <div style="margin-top:15px;text-align:right;overflow:hidden">
                            <div style="float:left;color:#f67c4f">{{error}}</div>
                            <button @click="submitForm()" type="button" class="btn btn-primary" style="border-radius:25px;padding:5px 20px;background:#526193 !important;border:1px solid #526193">{{$t('form_submit')}}</button>
                        </div>

     <div class="mask" id="mask">
            <div style="border-radius:5px;margin-top:150px;background:white;width:250px;margin-left:calc((100% - 250px)/2);text-align:center;padding:30px 15px">
                <div style="margin-bottom:15px"><i class="bi bi-check-circle-fill" style="color:#43b143;font-size:40px" ></i></div>
                <div style="font-size:14px;line-height:22px">
                    {{$t('form_submitted')}}
                </div>
                <div style="margin-top:20px">
                    <button @click="closeMask()" type="button" class="btn btn-primary" style="background:#526193 !important;border-radius:25px;border:none;padding:5px 30px !important;font-size:14px !important">OK</button>
                </div>
            </div>
      </div>
</div>
</template>

<script>

export default {
    created(){
    
    },
    mounted(){
        let url = "https://adabk2.chinacloudsites.cn/api/email";
        this.$http.get(url).then( res=>{
           
        })
    },
    props:[
        "productName"
    ],
    components: {
       
    },
    methods:{
        closeMask(){
            $("#mask").css("display","none");
            this.clear();
            $(window).scrollTop(0);
        },
        clear(){
            this.name = "";
            this.content = "";
            this.email = "";
            this.phone = "";  
        },
        submitForm(){
            
            let name = this.name;
            let content = this.content;
            let email = this.email;
            let phone = this.phone;

            let hasError = false;
            if(name == ""){
                $("#name").addClass("error");
                hasError = true;
            }
            else{
                $("#name").removeClass("error");
            }

            if(email == ""){
                $("#email").addClass("error");
                hasError = true;
            }
            else{
                $("#email").removeClass("error");
            }

            if(content == ""){
                $("#content").addClass("error");
                hasError = true;
            }
            else{
                $("#content").removeClass("error");
            }

            if(hasError){
                this.error = "Please input correct information.";
            }
            else{
                
                if(email.indexOf('@')<0){
                    this.error = "Email format is not correct.";
                    $("#email").addClass("error");
                    return;
                }
                else{
                    $("#email").removeClass("error");
                }


                this.error = "";

                let postInfo = {};
                if(!this.productName){
                    postInfo.title = "Product Inquiry";
                }
                else{
                    postInfo.title = "Product Inquiry: "+this.productName;
                }
                postInfo.name = name;
                postInfo.email = email;
                postInfo.phone = phone;
                postInfo.content = content;
                postInfo.all = postInfo.title+"   "+ postInfo.name + "   "+ postInfo.email + "    "+ postInfo.phone+"    "
                +postInfo.content;

                
                $("#mask").css("display","block");
                

                let url = "https://www.dctechonline.cn:8018/api/email/v2";
                this.$http.post(url,postInfo).then( res=>{
                    this.clear();
                    $(window).scrollTop(0);

                    var enhanced_conversion_data;
                    enhanced_conversion_data = { "email": email }
                    gtag('event', 'conversion', {'send_to': 'AW-851371510/GuVqCM3fh8ADENDvqrMo'});
                })

                url = "https://adabk2.chinacloudsites.cn/api/email";
                this.$http.post(url,postInfo).then( res=>{
                  
                })

                const {aplus_queue} = window;
                    // aplus_queue.push({
                    // action: 'aplus.sendPV',
                    // arguments: [{
                    //     is_auto: false
                    // }, postInfo]
                    // });

                    aplus_queue.push({
                    action: 'aplus.record',
                    arguments: ['adainquiry', 'CLK', postInfo]
                    });
            }
        }
    },
    data(){
        return {
            error:"",
            name:"",
            email:"",
            phone:"",
            content:""
        }
    }
};
</script>

<style>
input::placeholder{
    font-size:13px;
    color:#aaa !important;
}

textarea::placeholder{
    font-size:13px;
    color:#aaa !important;
}

input{
    font-size:13px !important;
    color:#333 !important;
}

button:focus{
 
    box-shadow:none !important;
}

textarea{
    font-size:13px !important;
}

.mask{
    background:rgba(0,0,0,0.5);
    position:fixed;
    width:100%;
    height:100%;
    z-index:200;
    left:0px;
    top:0px;
    display:none;
}

.error{
    border:1px solid #f67c4f;
}
</style>



// WEBPACK FOOTER //
// contact.vue?28dd0f69